import ProcessedOrders from "../../../Components/Admin/ProcessedOrders";
const ProcessedOrdersPage = () => {
  return <ProcessedOrders />;
};

export default ProcessedOrdersPage;
